import { Check, Dashboard } from '@mui/icons-material';
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from '@mui/material';
import React from 'react';

interface IProps {
  activeDashboard: string[];
  setActiveDashboard: Function;
}

export const ClientDasboardButton: React.FC<IProps> = ({
  activeDashboard,
  setActiveDashboard,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickMenuItem = (keyName: string) => {
    console.log(activeDashboard);
    if (activeDashboard.indexOf(keyName) !== -1) {
      setActiveDashboard([...activeDashboard.filter(x => x !== keyName)]);
      console.log(activeDashboard.filter(x => x !== keyName));
    } else {
      setActiveDashboard([...activeDashboard, keyName]);
    }
  };

  const getEntry = (keyName: string, titel: string) => {
    if (activeDashboard.indexOf(keyName) !== -1) {
      return (
        <MenuItem onClick={() => handleClickMenuItem(keyName)}>
          <ListItemIcon>
            <Check />
          </ListItemIcon>
          <ListItemText>{titel}</ListItemText>
        </MenuItem>
      );
    } else {
      return (
        <MenuItem onClick={() => handleClickMenuItem(keyName)}>
          <ListItemText inset>{titel}</ListItemText>
        </MenuItem>
      );
    }
  };

  return (
    <>
      <IconButton title='Dashboard konfigurieren' onClick={handleClick}>
        <Dashboard />
      </IconButton>
      <Menu
        id='demo-positioned-menu'
        aria-labelledby='demo-positioned-button'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {(
          [
            {
              key: 'PieChartLoggedUser',
              title: 'Eingeloggte neue Benutzer (letzte 7 Tage)',
            },
            { key: 'PieChartUser', title: 'Kontenverteilung' },
            { key: 'ComposedChartLogin', title: 'Anmeldungen (Monate)' },
            { key: 'ComposedDocuments', title: 'Dokumente (Monate)' },
            { key: 'PieChartBrowsers', title: 'Browserverteilung' },
            { key: 'PieChartOS', title: 'Betriebssystemverteilung' },
          ] as { key: string; title: string }[]
        ).map(entry => getEntry(entry.key, entry.title))}
      </Menu>
    </>
  );
};
